import angular from 'angular';

class PaymentsService {
  /**
   * Services Interface
   * @memberof pims
   * @ngdoc service
   * @param {service} $http xhr library
   */
  constructor($http, localStorageService, Endpoints) {
    'ngInject';

    Object.assign(this, {
      $http,
      localStorageService,
      Endpoints
    });
  } // getTransactionObject() {
  //   return this.$http.get(this.Endpoints.paymentMethods.object);
  // }


  postTransactionObject(user_id) {
    return this.$http.post(this.Endpoints.paymentMethods.object.replace(":user_id", user_id));
  }

  saveNewPaymentMethod(user_id, paymentData) {
    return this.$http.post(this.Endpoints.paymentMethods.addPaymentMethod.replace(":user_id", user_id), paymentData);
  }

  getCachePaymentServiceType() {
    var this2 = this;
    return new Promise(function (resolve, reject) {
      var paymentServiceType = this2.localStorageService.get('paymentServiceType');

      if (!paymentServiceType) {
        this2.$http.get(this2.Endpoints.paymentMethods.paymentService).then(({
          data
        }) => {
          this2.localStorageService.set('paymentServiceType', data);
          resolve(data);
        }).catch(err => {
          this2.localStorageService.set('paymentServiceType', null);
          resolve({
            service: ''
          });
        });
      } else {
        resolve(paymentServiceType);
      }
    });
  }

}

PaymentsService.$inject = ["$http", "localStorageService", "Endpoints"];
angular.module('pims').service('PaymentsService', PaymentsService);